const getters = {
    connected_wallet: state => state.app.connected_wallet,
    dkz_balance: state => state.app.dkz_balance
}
export default getters
